import HeroSection from '../../../../components/conduct-risk/HeroSection';
import { routesMap } from '../../../../routes/AppRoutes';
import { formatTitle } from '../../../../utils/Format';
import { Reports } from '../../../../api/apiTypes';

interface DataFromParent {
  report: Reports | undefined;
  title: string | undefined;
  reportId?: string;
}

const BannerReclami = ({ report, title, reportId }: DataFromParent) => {
  const formattedTitle = formatTitle(title);
  return (
    <HeroSection
      title={formattedTitle ?? ''}
      description="Consulta e analizza i reclami per intermediario."
      breadcrumbLinks={[
        { url: routesMap.HOME_PAGE, title: 'Home' },
        { url: routesMap.BEST_EXECUTION_HOME, title: 'Best Execution' },
        { url: routesMap.REPORT_PAGE, title: 'Report' },
        { url: routesMap.VISUALIZZA_REPORT(report?.name ?? ''), title: report?.name ?? '', state: { id: reportId } },
        { url: '#', title: formattedTitle ?? '' },
      ]}
    />
  );
};

export default BannerReclami;
